// The operator's words for the platform's concepts. The platform thinks in Experiences,
// Instances and add-ons; Renedian says Tour Template, Tour and Excursion, and never has to
// see the platform's words on screen. Leadership sets the words under Leadership →
// Policies → Glossary (`settings/glossary`); the defaults below are Renedian's and apply
// until that document exists. One word per concept, singular and plural. [Aaron
// 2026-08-26, 2026-09-04, 2026-09-24]

export const TERMS = Object.freeze([
  {
    key: 'experience',
    concept: 'Experience',
    meaning: 'The reusable definition a tour is built from: itinerary, vehicles, content and pricing. Every scheduled tour is copied from one.',
    singular: 'Tour Template',
    plural: 'Tour Templates',
  },
  {
    key: 'instance',
    concept: 'Instance',
    meaning: 'One scheduled running of an Experience, with its own dates, riders, crew and hotels. It moves through the tour phases.',
    singular: 'Tour',
    plural: 'Tours',
  },
  {
    key: 'addOn',
    concept: 'Add-on',
    meaning: 'An Experience attached before or after another and sold with it. It runs as its own Instance, linked to the main one.',
    singular: 'Excursion',
    plural: 'Excursions',
  },
])

export const TERM_KEYS = Object.freeze(TERMS.map((t) => t.key))

const str = (v) => (typeof v === 'string' ? v.trim() : '')

/** `settings/glossary` (or nothing) → { experience: { singular, plural }, … }, defaults filling the gaps. */
export function normalizeGlossary(doc) {
  const src = (doc && doc.terms) || {}
  const out = {}
  TERMS.forEach((t) => {
    const r = src[t.key] && typeof src[t.key] === 'object' ? src[t.key] : {}
    out[t.key] = { singular: str(r.singular) || t.singular, plural: str(r.plural) || t.plural }
  })
  return out
}

/** The operator's word for a concept: termOf(g, 'experience') → 'Tour Template'; { plural, lower } as asked. */
export function termOf(glossary, key, { plural = false, lower = false } = {}) {
  const entry = (glossary && glossary[key]) || normalizeGlossary(null)[key]
  if (!entry) return key
  const word = plural ? entry.plural : entry.singular
  return lower ? word.toLowerCase() : word
}
